import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_DOMAIN_PREBID_MODULES: TypedDocumentNode<Data, Variables> = gql`
  ${ALERT_FRAGMENT}

  query domainPrebidModules(
    $domainId: ID!
    $moduleType: PrebidModuleTypeEnum
    $sort: DomainPrebidModuleSortInput
  ) {
    domainPrebidModules(domainId: $domainId, moduleType: $moduleType, sort: $sort) {
      nodes {
        id
        createdAt
        enabled
        fieldAlerts {
          ...AlertFragment
        }
        prebidModule {
          id
          demand
          name
        }
        updatedAt
        workspacePrebidModule {
          id
        }
      }
    }
  }
`
